import { Radio, Checkbox } from 'antd';
import Text from 'components/Text/Text';
import { AppContext, IAppContext } from 'appState/appContext';
import React, { useContext } from 'react';
import { DevicesNotificationTypes } from 'types';
import ModalSentSuccessfully from 'components/ModalWindows/ModalSentSuccessfully';
import ModalSentError from 'components/ModalWindows/ModalSentError';
import { ModalToConfirm } from 'components/ModalWindows/ModalToConfirm';
import DropboxPushModal from './DropboxPushModal/DropboxPushModal';
import {
	DeviceFullInfoContext,
	IDeviceFullInfoContext,
} from 'modules/Devices/DeviceFullInfo/deviceFullInfoState/deviceFullInfoContext';
import { pushDeviceNotifications } from 'backend/devices';
import classNames from 'classnames';
import style from './ModalWindows.module.scss';

const ModalWindows: React.FC = () => {
	const { showLoader, hideLoader } = useContext<IAppContext>(AppContext);
	const {
		changeTypeOfModalWindow,
		resetDropboxPushFields,
		switchBackupEnabled,
		setDeactivateDeviceWithRemoveContent,
		setDeactivateDeviceWithResetRestaurant,
		resetModalState,
		dataForPush,
		isBackupEnabled,
		isDeactivateDeviceWithRemoveContent,
		isDeactivateDeviceWithResetRestaurant,
		typeOfModalWindow,
	} = useContext<IDeviceFullInfoContext>(DeviceFullInfoContext);
	const containerClasses = classNames(style.container, { [style.visible]: typeOfModalWindow });

	const sendPush = async () => {
		if (dataForPush && typeOfModalWindow) {
			try {
				showLoader();
				if (dataForPush.data.notificationType === DevicesNotificationTypes.PushDeactivateDevice) {
					await pushDeviceNotifications(dataForPush.hardwareId, {
						...dataForPush.data,
						// metadata: {
						// 	removeContent: isDeactivateDeviceWithRemoveContent,
						// 	clearRestaurant: isDeactivateDeviceWithResetRestaurant,
						// 	isBackupEnabled: isBackupEnabled,
						// },
					});
				} else {
					await pushDeviceNotifications(dataForPush.hardwareId, dataForPush.data);
				}
				changeTypeOfModalWindow('success');
				resetDropboxPushFields();
			} catch (err) {
				changeTypeOfModalWindow('error');
			} finally {
				resetModalState();
				hideLoader();
			}
		}
	};

	const handleCancelDropboxPush = () => {
		changeTypeOfModalWindow(null);
		resetDropboxPushFields();
	};

	const handleCloseModal = () => {
		changeTypeOfModalWindow(null);
		resetModalState();
	};

	const clearAndClose = () => {
		handleCloseModal();
	};

	const enableBackup = () => {
		switchBackupEnabled(true);
	};

	const disableBackup = () => {
		switchBackupEnabled(false);
	};

	const toggleDeactivateDeviceWithRemoveContent = () => {
		setDeactivateDeviceWithRemoveContent();
	};

	const toggleDeactivateDeviceWithResetRestaurant = () => {
		setDeactivateDeviceWithResetRestaurant();
	};

	return (
		<div className={containerClasses} data-test="ModalWindows">
			<ModalToConfirm
				onConsentEvent={sendPush}
				onFailureEvent={handleCloseModal}
				isVisible={typeOfModalWindow === 'confirm'}
				description="pushInfo"
				typeOfInfoIcon="toConfirmPush"
				// additionalContent={
				// 	dataForPush?.data.notificationType === 'PushDeactivateDevice' && (
				// 		<div className={style.additionalControl}>
				// 			<div className={style.additionalControlContent}>
				// 				<div className={style.additionalSelectsWrapper}>
				// 					<Radio checked={isBackupEnabled} onClick={enableBackup}>
				// 						<Text
				// 							translationNameSpace="form"
				// 							translationKey="withBackupLabel"
				// 							asFragment={true}
				// 						/>
				// 					</Radio>
				// 					<Radio checked={!isBackupEnabled} onClick={disableBackup}>
				// 						<Text
				// 							translationNameSpace="form"
				// 							translationKey="withoutBackupLabel"
				// 							asFragment={true}
				// 						/>
				// 					</Radio>
				// 				</div>
				// 				{!isBackupEnabled && (
				// 					<div className={style.additionalSelectsWrapper}>
				// 						<Checkbox
				// 							className={style.checkbox}
				// 							checked={isDeactivateDeviceWithRemoveContent}
				// 							onChange={toggleDeactivateDeviceWithRemoveContent}>
				// 							<Text
				// 								translationNameSpace="modals"
				// 								translationKey="clearContentLabel"
				// 								asFragment={true}
				// 							/>
				// 						</Checkbox>
				// 						<Checkbox
				// 							className={style.checkbox}
				// 							checked={isDeactivateDeviceWithResetRestaurant}
				// 							onChange={toggleDeactivateDeviceWithResetRestaurant}>
				// 							<Text
				// 								translationNameSpace="modals"
				// 								translationKey="resetRestaurantLabel"
				// 								asFragment={true}
				// 							/>
				// 						</Checkbox>
				// 					</div>
				// 				)}
				// 			</div>
				// 		</div>
				// 	)
				// }
			/>
			<ModalSentSuccessfully
				onConsentEvent={clearAndClose}
				isVisible={typeOfModalWindow === 'success'}
				description="pushSuccessfully"
			/>
			<ModalSentError
				onConsentEvent={handleCloseModal}
				isVisible={typeOfModalWindow === 'error'}
				description="errorWhileSendingPush"
			/>
			<DropboxPushModal
				onFailureEvent={handleCancelDropboxPush}
				isVisible={typeOfModalWindow === 'dropBoxPush'}
			/>
		</div>
	);
};

export default ModalWindows;
